<dashboardnav>

    <cradua-seismicparty
    [contractors]="contractors$ | async"
    [seismicpartys]="seismicpartys$ | async"
  
    (changeEmit)="onSubmitSeismicParty($event)"
    (deleteEvent)="onDeleteSeismicParty($event)"
    *ngIf="
    !(isLoadingContractor$ | async ) &&
    !(isLoadingSeismicParty$ | async )
    "
    >
    </cradua-seismicparty>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="
    (isLoadingContractor$ | async ) ||
    (isLoadingSeismicParty$ | async )
    "
  >
    </mrsoftapps-epims-reference-spinner>
  </dashboardnav>
  